// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let MarkupData = function (typeId, formula, markups)
{
    this.TypeId = typeId
    this.Formula = formula
    this.Markups = markups
}

MarkupData.prototype.toString = function ()
{
    return this.TypeId.toString()
}